/**
 * Compose a human-friendly duration label from a service object.
 * Priority: explicit `duration_label` → `duration_value + duration_unit` →
 * legacy `duration_minutes` → null.
 */
export function formatServiceDuration(s, t) {
  if (!s) return null;
  if (s.duration_label) return s.duration_label;
  if (s.duration_value && s.duration_unit) {
    const n = Number(s.duration_value);
    const unit = s.duration_unit;
    const isOne = Math.abs(n - 1) < 0.001;
    const key = `service_duration.${unit}_${isOne ? "one" : "other"}`;
    const fallback = isOne
      ? { minutes: "1 minute", hours: "1 hour", days: "1 day", nights: "1 night", weeks: "1 week", sessions: "1 session" }[unit]
      : { minutes: `${n} minutes`, hours: `${n} hours`, days: `${n} days`, nights: `${n} nights`, weeks: `${n} weeks`, sessions: `${n} sessions` }[unit];
    return t ? t(key, fallback, { count: n }) : fallback;
  }
  if (s.duration_minutes) {
    const m = Number(s.duration_minutes);
    if (m >= 60 && m % 60 === 0) {
      const h = m / 60;
      return t ? t(h === 1 ? "service_duration.hours_one" : "service_duration.hours_other", h === 1 ? "1 hour" : `${h} hours`, { count: h }) : (h === 1 ? "1 hour" : `${h} hours`);
    }
    return t ? t("service_duration.minutes_other", `${m} minutes`, { count: m }) : `${m} minutes`;
  }
  return null;
}
